import { Component, inject, ViewEncapsulation } from '@angular/core';
import { Check, LucideAngularModule } from 'lucide-angular';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-region-toast',
  template: `
    <div class="flex items-center gap-3">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18ZM13.857 8.191C13.9149 8.11129 13.9566 8.02095 13.9796 7.92514C14.0026 7.82933 14.0065 7.72994 13.991 7.63262C13.9756 7.5353 13.9412 7.44198 13.8897 7.35797C13.8382 7.27396 13.7707 7.20091 13.691 7.143C13.6113 7.08509 13.5209 7.04344 13.4251 7.02044C13.3293 6.99744 13.2299 6.99354 13.1326 7.00895C13.0353 7.02437 12.942 7.0588 12.858 7.11028C12.774 7.16176 12.7009 7.22929 12.643 7.309L9.16 12.099L7.28 10.219C7.21078 10.1474 7.128 10.0903 7.03647 10.051C6.94495 10.0118 6.84653 9.99114 6.74694 9.99032C6.64736 9.9895 6.54861 10.0085 6.45646 10.0463C6.3643 10.084 6.28059 10.1398 6.2102 10.2102C6.13982 10.2807 6.08417 10.3644 6.0465 10.4566C6.00883 10.5488 5.9899 10.6476 5.99081 10.7472C5.99173 10.8467 6.01246 10.9451 6.05181 11.0366C6.09116 11.1281 6.14834 11.2108 6.22 11.28L8.72 13.78C8.79663 13.8567 8.88896 13.9158 8.99065 13.9534C9.09233 13.9909 9.20094 14.006 9.30901 13.9975C9.41708 13.9891 9.52203 13.9573 9.61663 13.9044C9.71123 13.8515 9.79324 13.7787 9.857 13.691L13.857 8.191Z"
          fill="#0A0A0A"
        />
      </svg>
      <div class="flex flex-col">
        <span class="text-neutral-950 text-xs font-normal leading-5">{{ toastPackage.title }}</span>
        <span class="text-[#394660] text-xs font-normal leading-5 w-72">{{ toastPackage.message }}</span>
      </div>
    </div>
  `,
  styles: `
    .region-toast {
      display: block;
      width: fit-content !important;
      background-color: #fff !important;
      border: 1px solid #000;
      border-radius: 8px !important;
      padding: 12px !important;
      box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1) !important;
      max-width: 356px;
    }
  `,
  imports: [LucideAngularModule],
  encapsulation: ViewEncapsulation.None,
})
export class RegionToastComponent extends Toast {
  checkIcon = Check;
  constructor() {
    super(inject(ToastrService), inject(ToastPackage));
  }
}
